import React from "react";
import LeftNav from "../components/5-left-nav";
import LocalInterests from "../components/8-local-interests";
import Footer from "../components/9-contact-footer";

const LI = () => {
  return (
    <div>
      <LeftNav></LeftNav>
      <LocalInterests />
      <Footer></Footer>
    </div>
  );
};

export default LI;
